import React from 'react';
import {View as RNView} from 'react-native';

import {Button} from '../../../../shared/components/button';
import GetStyles from '../../styles';

export const View = (props: {onClick: () => Promise<void>; hide: boolean}) => {
  const styles = GetStyles();

  if (props.hide) {
    return <RNView />;
  }
  return (
    <Button
      id='notifications-read-all'
      onPress={props.onClick}
      style={styles.allToReadButton}
      text='Все в прочитанные'
      type='secondary'
    />
  );
};
